<template>
  <div>
    <div class="header">
      <div class="user">
        <div class="user-side" style="background: #07A905;"></div>
        <div class="user-item">
          <div v-if="loginFlag">
            <el-popover
              placement="bottom"
              trigger="click"
              popper-class='person-popover'
              v-model="popoverVisible">
                <div class="person-bt" @click="toUserCenter()">个人中心</div>
                <div class="person-bt" @click="handleLogout()" style="margin-top: 0.5rem">退出登录</div>
              <div slot="reference" class="person">
                <img class="head-img" :src="userInfo.photo?Files+userInfo.photo:defaultHeadImg">
                <el-badge :value="msgNum" :max="99" style="top:3px;" :hidden="!msgNum">
                  <span style="margin-bottom: 3px;display: inline-block;">{{ userInfo.realname }}</span>
                </el-badge>
              </div>
            </el-popover>
          </div>
          <div v-else>
            <span @click="dialogFormVisible = true">登录</span>
            <span style="margin-left: 8px" @click="handleRegist()">注册</span>
          </div>
        </div>
        <div class="user-side" style="background: #000000;"></div>
      </div>
      <div class="search">
        <div class="search-item">
          <img class="logo" @click="handleHome()" src="@/assets/img/logoHead.png">
          <div class="right">
            <el-input placeholder="搜索课程" v-model="className">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
              <template slot="append">
                <el-button type="primary" size="mini" @click="search()">
                  搜索
                </el-button>
              </template>
            </el-input>
            <img class="qrcode" :src="Files+'index.jpg'">
          </div>
        </div>
      </div>
    </div>

    <el-dialog class="login-dialog" title="登录" :visible.sync="dialogFormVisible">
      <img class="login-logo" src="@/assets/img/logoHead.png">
      <el-form :model="loginForm" class="login-form">
        <el-form-item>
          <el-input v-model="loginForm.username" placeholder="用户名/手机号">
            <template slot="suffix">
              <img class="login-icon" src="@/assets/person.svg">
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="loginForm.password" type="password" placeholder="密码">
            <template slot="suffix">
              <img class="login-icon" src="@/assets/lock.svg">
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="forgotPassword">
        <el-link type="success" style="margin-right: 154px;" @click="handleRegistered">去注册</el-link>
        <el-link type="success" @click="handleForgotPassword">忘记密码</el-link>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleLogin()">登录</el-button>
      </div>
    </el-dialog>

    <el-dialog class="login-dialog forgotPassword" title="忘记密码" :visible.sync="dialogFormVisible1">
      <el-form ref="forgotPassword" :rules="rules" :model="forgotPasswordForm" label-width="110px">
        <el-form-item label="手机号码" prop="mobile">
          <el-input placeholder="请输入手机号码" v-model="forgotPasswordForm.mobile">
            <template slot="append">
              <div @click="handleGetCode" style="cursor: pointer;">
                {{ canGetCode ? '获取验证码' : '重新获取(' + this.totalTime + 's)' }}
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="smsCode"> <el-input placeholder="请输入验证码" v-model="forgotPasswordForm.smsCode"></el-input> </el-form-item>
        <el-form-item label="设置新密码" prop="newPassword"> <el-input placeholder="请设置新密码" type="passowrd" v-model="forgotPasswordForm.newPassword"></el-input> </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword"> <el-input placeholder="请设置确认新密码" type="passowrd" v-model="forgotPasswordForm.confirmPassword"></el-input> </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleForgotPassword">返回</el-button>
        <el-button @click="handleSubmit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { login, getUserInfo, getResetSmsCode, resetPassword } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { Files } from '@/common/config'
export default {
  name: 'Header',
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请设置确认新密码'));
      } else if (value !== this.forgotPasswordForm.newPassword) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      // userInfo: {
      //   username: '',
      //   photo: ''
      // },
      Files,
      defaultHeadImg: 'https://dss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=4056769380,3332572838&fm=111&gp=0.jpg',
      className: '',
      dialogFormVisible: false,
      dialogFormVisible1: false,
      loginForm: {
        username: '',
        password: ''
      },
      totalTime: 120,
      canGetCode: true,
      forgotPasswordForm: {
        confirmPassword: '',
        mobile: '',
        newPassword: '',
        smsCode: ''
      },
      rules: {
        mobile: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请设置新密码', trigger: 'blur' }],
        confirmPassword: [{ required:true, validator: validatePass, trigger: 'blur' }]
      },
      // loginFlag: false,
      popoverVisible: false
    }
  },
  created() {
    this.checkLogin()
  },
  computed: {
    ...mapState({
      msgNum: state => state.user.msgNum
    }),
    reLogin() {
      return this.$store.getters.reLogin
    },
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  watch:{
    reLogin(val,oldVal) {
      if(this.reLogin){
        this.dialogFormVisible = true
        this.$store.dispatch('user/reLogin', false)
      }
    }
  },
  methods: {
    handleGetCode() {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.forgotPasswordForm.mobile)) return
      if (!this.canGetCode) return
      getResetSmsCode({ mobile: this.forgotPasswordForm.mobile, type: 2 }).then(response => {
        this.canGetCode = false
        let clock = window.setInterval(() => {
          this.totalTime--
          if (this.totalTime < 0) {
            window.clearInterval(clock)
            this.totalTime = 120
            this.canGetCode = true
          }
        },1000)
      })
    },
    handleSubmit() {
      this.$refs['forgotPassword'].validate((valid) => {
        if (valid) {
          resetPassword(this.forgotPasswordForm).then(res => {
            this.$message({message: '找回密码成功', type: 'success'})
            this.handleForgotPassword()
          })
        }
      })
    },
    handleForgotPassword() {
      this.dialogFormVisible = !this.dialogFormVisible
      this.dialogFormVisible1 = !this.dialogFormVisible1
    },
    handleRegistered(){
      this.dialogFormVisible = false
      this.$router.push({ path: '/regist'})
    },
    checkLogin() {
      if(getToken()) {
        this.loginFlag = true
        this.getUserInfo()
      }else{
        this.loginFlag = false
      }
    },
    handleLogin() {
      this.$store.dispatch('user/login', this.loginForm).then((res) => {
        this.loginFlag = true
        this.dialogFormVisible = false
        this.getUserInfo()
        // this.$router.go(0);
        window.location.reload();

      })
      .catch(() => {

      })
    },
    handleLogout() {
      this.$store.dispatch('user/logout', this.loginForm).then(() => {
        // this.userInfo = response.data.loginUser
        this.popoverVisible = false
        this.loginFlag = false
        window.location.reload();


        window.localStorage.removeItem('neiwei')
      })
    },
    getUserInfo() {
      this.$store.dispatch('user/getInfo', this.loginForm).then((res) => {
        console.log(res);
        //保存
        window.localStorage.setItem('touxiang',JSON.stringify(res.photo))
        // this.userInfo = response.data.loginUser
      })
    },
    toUserCenter() {
      this.popoverVisible = false
      this.$router.push({ path: '/person-info' })
    },
    handleRegist() {
      this.$router.push({ path: '/regist'})
    },
    handleHome() {
      this.$router.push({ path: '/'})
    },
    search() {
      this.$router.push({ path: '/course/search', query: { title: this.className }})
      this.className = ''
      // this.$router.go(0)
    }
  }
}
</script>
<style lang="scss">
.person-popover{
  min-width: auto;
  background: rgba(0,0,0,0.7);
  color: #ffffff;
  padding: 0.5rem 1rem;
  border: none;
  .person-bt{
    cursor: pointer;
  }
}
</style>
<style lang="scss" scoped>
.header{
  // position: fixed;
  // top: 0;
  width: 100%;
  height: 9rem;
  z-index: 1000;

  .user{
    display: flex;
    background: #000000;
    height: 2.5rem;

    &-item{
      flex: 0 0 62.87rem;
      color: #07A903;
      font-size: 1.1rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .person{
        display: flex;
        align-items: center;
        .head-img{
          width: 1.57rem;
          height: 1.57rem;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 0.63rem;
        }
      }

      span{
        cursor:pointer;
      }
    }
    &-side{
      flex: 1 1 auto
    }
  }
  .search{
    display: flex;
    justify-content: center;
    background: #ffffff;
    height: 6.5rem;
    border-bottom: 1px solid #cccccc;

    &-item{
      width: 62.87rem;
      display: flex;
      justify-content: space-between;

      .logo{
        width: 16.5rem;
        height: 3.5rem;
        margin-top: 1.57rem;
        cursor:pointer;
      }
      .right{
        display: flex;
        justify-content: flex-end;
        /deep/ .el-input{
          font-size: 1.1rem;
          height: 2.5rem;
          width: 23.69rem;
          margin-top: 1.57rem;
          box-sizing: border-box;

          input{
            height: 2.5rem;
          }

          .el-input__icon{
            line-height: 2.5rem;
          }

          .el-button--primary{
            color: #fff;
            background-color: #00A903;
            border-color: #00A903;
            height: 2.5rem;
            width: 6.25rem;
          }
        }

        .qrcode{
          width: 4.18rem;
          height: 4.05rem;
          margin-top: 0.82rem;
          margin-left: 2.52rem;
        }
      }
    }
  }
}
.forgotPassword{
  /deep/ .el-dialog{
    .el-input{
      width: 100% !important;
    }
    .dialog-footer{
      display: flex;
      justify-content: center;
      .el-button{
        width: 10rem !important;
        &:first-child{
          background: initial;
          color: #6a6c70;
        }
      }
    }
  }
}
.login-dialog{
  /deep/ .el-dialog{
    width: 32rem;
    .el-dialog__header{
      text-align: left;
    }
    .el-input{
      width: 16rem;
      height: 2.5rem;
      .el-input__suffix-inner{
        height: 90%;
        display: flex;
        align-items: center;
      }
    }
    .el-dialog__footer{
      text-align: center;
      padding-bottom: 4rem;
      .el-button{
        background: #07A905;
        color: #ffffff;
        font-size: 1rem;
        width: 16rem;
      }
    }
  }
  .forgotPassword{
    width: 16rem;
    margin: 0 auto;
    text-align: right;
  }
  .login-logo{
    width: 16rem;
    height: 3.69rem;
    margin: 3rem 0 3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue